<template>
	<div>
		<v-text-field
			browser-autocomplete="off"
			label="label pola"
			aria-label="label"
			for="text-field-props-label"
			id="text-field-props-label"
			v-model="fieldProps.label"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="hint"
			aria-label="hint"
			for="text-field-props-hint"
			id="text-field-props-hint"
			v-model="fieldProps.hint"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="minimalna liczba znaków"
			aria-label="min character number"
			for="text-field-props-min-number-marks"
			id="text-field-props-min-number-marks"
			v-model="fieldProps.min"
			type="number"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="maksymalna liczba znaków"
			aria-label="max character number"
			for="text-field-props-max-number-marks"
			id="text-field-props-max-number-marks"
			v-model="fieldProps.max"
			type="number"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-expand-transition>
			<div v-show="fieldProps.max > 32767" style="color: red; display: flex; justify-content: center;" class="ml-3 mr-3">
				Maksymalna liczba znaków nie może przekroczyć 32767.
			</div>
		</v-expand-transition>
		<v-checkbox v-model="fieldProps.required" :label="`Wymagane`" aria-label="mandatory"></v-checkbox>
		<v-checkbox v-model="fieldProps.view" :label="`Wyświetlanie na podglądzie`"
			aria-label="show on print view"></v-checkbox>
	</div>
</template>
<script>
	export default {
		name: "textFieldProps",

		watch: {
			fieldProps: {
				handler() {
					this.$emit("input", this.fieldProps);
				},
				deep: true,
			},
		},

		props: {
			value: Object,
		},

		data() {
			return {
				fieldProps: this.value,
			};
		},
	};
</script>

<style scoped>

</style>
